module.exports = __webpack_public_path__ + "img/Paxos.3cfa131e.png";